import React from 'react'
import JustRow from "../../../styleHelper/JustRow"
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Fade from 'react-reveal/Fade'; 
import { withStyles, makeStyles  } from '@material-ui/core/styles';
import Slider from "@material-ui/core/Slider";


const useStyles = makeStyles(() => ({
    slidersRow:{
        marginBottom:"20px",
        "& .flexBox":{
            marginTop:"45px",
            alignItems:"center"
        }
    },
    slidersRowLabel:{
        width:"200px",
        fontSize:".8em",
        textAlign:"right"
    }
  }));

export default function MakePackage(props){
    const classes = useStyles();
    const PrettoSlider = withStyles({
        root: {
          color: '#45c6be',
          height: 3,
        },
        thumb: {
          height: 15,
          width: 15,
          backgroundColor: '#fff',
          border: '2px solid currentColor',
          marginTop: -5,
          marginLeft: -7,
          '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
          },
        },
        active: {},
        valueLabel: {
          left: 'calc(-50% - 4px)',
          color:"#45c6be"
        },
        track: {
          height: 3,
          borderRadius: 0,
        },
        rail: {
          height: 3,
          borderRadius: 0,
          color: '#c0c5ce',
        },
      })(Slider);
    return(
        <JustRow description="در صورتی که پلن های بالا پاسخگوی نیاز شما نیست:" rowClass="justify-content-center">
            <Col sm={12} md={10} lg={8}>
                <Fade bottom distance="50px">
                    <Card className="text-center grayBg">
                        <Card.Body>
                            <Card.Title>بسته به نیاز خود انتخاب کنید</Card.Title>
                            <div className={classes.slidersRow}>
                            <div className="flexBox">
                                <span className={classes.slidersRowLabel}>تعداد شرکت کننده</span>
                                <PrettoSlider
                                    valueLabelDisplay="on"
                                    defaultValue={10}
                                    step={1}
                                    min={1}
                                    max={100}
                                />
                            </div>
                            <div className="flexBox">
                                <span className={classes.slidersRowLabel}>تعداد ویدئو همزمان</span>
                                <PrettoSlider
                                    valueLabelDisplay="on"
                                    defaultValue={3}
                                    step={1}
                                    min={1}
                                    max={100}
                                />
                            </div>
                            <div className="flexBox">
                                <span className={classes.slidersRowLabel}>مدت زمان استفاده (ماه)</span>
                                <PrettoSlider
                                    valueLabelDisplay="on"
                                    defaultValue={1}
                                    step={1}
                                    min={1}
                                    max={12}
                                />
                            </div>
                            </div>
                            <hr/>
                            <div className="flexBox centerCenter">
                                <span>مبلغ قابل پرداخت:</span>
                                <div className="priceBox">۱,۴۳۰,۰۰۰<span className="curency">تومان</span></div>
                                <a href="/" className="btn btn-primary">شروع کنید</a>
                            </div>
                        </Card.Body>
                    </Card>
                </Fade>
            </Col>
        </JustRow>
    )
}